import { z } from 'zod';
export const PayeeMapping = z.object({
    id: z.number().int(),
    payee_normalized: z.string(),
    item_id: z.number().int(),
    updated_at: z.string(),
});
export const UpsertPayeeMappingRequest = z.object({
    payee_normalized: z.string().min(1).max(255),
    item_id: z.number().int().positive(),
});
